// extracted by mini-css-extract-plugin
export default {"Box":"no-iterations-placeholder-module__Box--kRcnY","Text":"no-iterations-placeholder-module__Text--PJHsR","Text_1":"no-iterations-placeholder-module__Text_1--HFzBO"};